<template>
  <div class="raise-box-wrapper">
    <div class="raise-box-content">
      <div class="close-btn" @click="handleClickClose"></div>
      <div class="gifts-header">
        <h2>免费礼物</h2>
        <div class="header">点击礼物可发送上屏<span>限时免费</span></div>
      </div>
      <div class="content">
        <ul>
          <li v-for="(item, i) in gifts" :key="i" @click="sendGift(item)">
            <div class="gift-img">
              <img :src="item.thumbnail" />
            </div>
            <div class="gift-name">{{ item.name }}</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { chttp, apis } from '@/libs/interfaces';
import mixinOldVip from '@/mixins/vip-toast-test';

export default {
  mixins: [mixinOldVip],
  computed: {
    ...mapState({
      openid: (item) => item.openid,
      unionid: (item) => item.unionid,
    }),
  },
  data() {
    return {
      gifts: [],
    };
  },
  methods: {
    async getGiftData() {
      const params = {
        giftType: 22,
      }
      const result = await chttp.get(apis.getPagGift, { params })
      this.gifts = result.data || []
    },
    sendGift(item) {
      this.$sendLog({
        event_type: 'click',
        event_name: 'pag大屏礼物弹窗-点击发送',
        event_data: {
          name: item.name,
        },
      });
      const params = {
        openid: this.openid,
        unionid: this.unionid,
        gift_name: item.name,
        pic: item.thumbnail,
        stb_pic: item.effect,
        count: 1,
        giftId: item.id,
        giftType: 22,
      };
      chttp.post('/vod/gift/send', params)
        .then((res) => {
          if (res.errcode === 200) {
            this.$toast({ toastTxt: '<span style="white-space:nowrap">发送成功，请看大屏幕</span>' });
          } else {
            this.$toast('网络不稳定，请稍后再试');
          }
        });
    },
    handleClickClose() {
      this.$store.commit('SAVE_SHOW_GIFT_BOX', false)
    },
  },
  created() {
    this.getGiftData()
    this.$sendLog({
      event_type: 'show',
      event_name: '免费礼物弹窗',
      event_data: {
        action: '已点页右上角',
      },
    });
  },
};
</script>
<style lang="scss" scoped>
.raise-box-wrapper {
  @include background_color('mask-background');
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
}
.raise-box-content {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 750px;
  height: 80vh;
  background-image: linear-gradient(180deg, #E1354D 0%, #B64756 80%);
  border-radius: 30px 30px 0 0;
  .gifts-header {
    position: absolute;
    top: 0px;
    width: 100%;
    z-index: 2;
    font-size: 32px;
    text-align: center;
    color: #fff;
    height: 180px;
    padding-top: 40px;
    border-radius: 30px 30px 0 0;
    h2{
      font-size: 40px;
      font-weight: 600;
    }
    .header{
      display: flex;
      justify-content: center;
      align-items: center;
    }
    span{
      font-size: 22px;
      color: #bc2e41;
      background: #fff;
      border-radius: 10px 9px 9px 0px;
      padding: 2px 10px;
      margin-left: 10px;
    }
  }
  .content {
    margin-top: 180px;
    padding-left: 30px;
    height: calc(80vh - 180px);
    overflow-y: auto;
    ul {
      list-style: none; /* 移除列表默认样式 */
      display: flex; /* 启用flex布局 */
      flex-wrap: wrap; /* 允许列表换行 */
      justify-content: left; /* 在列表项之间添加空间 */
      padding-bottom: 50px;
    }
    li {
      width: 220px;
      margin: 0px 15px 30px 0px;
      border-radius: 16px;
      &:first-child {
        margin-top: 0;
      }
    }
    .gift-img {
      width: 220px;
      height: 220px;
      border-radius: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 0.1);
      img{
        width: 180px;
        height: 180px;
      }
    }
    .gift-name {
      font-size: 28px;
      text-align: center;
      color: rgba(255, 255, 255, 0.7);
      margin-top: 12px;
    }
  }
}
.close-btn {
  position: absolute;
  top: -100px;
  right: 30px;
  width: 54px;
  height: 54px;
  background: url('https://qncweb-back1.ktvsky.com/20230602/other/c80fe11d35b1a3ffd913691288826613.png') no-repeat center center;
  background-size: contain;
  z-index: 10;
}
</style>
